import { render, staticRenderFns } from "./TiptapToolbarBtn.vue?vue&type=template&id=0922750c&scoped=true"
import script from "./TiptapToolbarBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./TiptapToolbarBtn.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TiptapToolbarBtn.vue?vue&type=style&index=0&id=0922750c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0922750c",
  null
  
)

export default component.exports